/**
 * Whether opened items show above the wall: always on the web; on desktop
 * while the Workspace is open (a preview), not in Focus over the desktop.
 */
import { isTauri } from "@/lib/is-tauri";
import { useDesktopMode } from "@/stores/desktop-mode-store";

export function useAboveWall(): boolean {
  const workspaceOpen = useDesktopMode((state) => state.mode === "denk");
  return !isTauri() || workspaceOpen;
}
